import React from "react";
import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

import image1 from "assets/img/banner/welcome.svg";
import image2 from "assets/img/banner/fee.svg";
import image3 from "assets/img/banner/onekey.svg";
import image4 from "assets/img/banner/full.svg";
import i18next from "i18next";

export default function Welcome() {
  const navigate = useNavigate();
  const {
    authStore: { questions },
  } = useStores();

  return (
    <div className="flex flex-col bg-black h-screen">
      <div className="flex items-center justify-end px-6 h-16 ">
        <Link className="text-sm text-white" to="/board">
          {i18next.t("skip")}
        </Link>
      </div>
      <div className="pt-[70px]">
        <Swiper
          spaceBetween={30}
          centeredSlides
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          className="swiper2"
        >
          <SwiperSlide>
            <div className="w-full h-full flex flex-col items-center">
              <img alt="" src={image1} style={{ height: 250 }} />
              <h2 className="text-[32px] text-white pt-8">
                {i18next.t("note26")}
              </h2>
              <span className="text-sm text-center text-[#888]">
                {i18next.t("note27")}
              </span>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="flex-1 flex px-4 bg-black">
        <Link
          className="h-fit self-end mb-[70px] flex-1 py-[6px] px-4 bg-[#3d5afe] hover:bg-[#2a3eb1] text-sm text-white text-center rounded"
          to="/language"
        >
          {i18next.t("note28")}
        </Link>
      </div>
    </div>
  );
}
